<input
    matInput readonly type="text" [placeholder]="placeholder"
    [ngbPopover]="tmplDateRangePicker" #popoverDatePicker="ngbPopover"
    autoClose="outside"
    popoverClass="popover-fill-content" container="body" placement="auto"
    [value]="getInputText | call:value"
    [matTooltip]="getInputTooltip | call:value:showInputTooltip"
    [matTooltipPosition]="inputTooltipPosition" matTooltipClass="text-preline"
/>
<button *ngIf="value" mat-button mat-icon-button aria-label="Clear" title="Clear"
    (click)="$event.stopPropagation(); onChangeFilterDateRange(null)">
    <i class="far fa-times"></i>
</button>

<ng-template #tmplDateRangePicker>
  <app-date-range-picker
    [selection]="value"
    (selectionChange)="onChangeFilterDateRange($event); popoverDatePicker.close()"
    [local]="local"
    (click)="$event.stopPropagation()">
  </app-date-range-picker>
</ng-template>
